import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'ts-skeleton',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './ts-skeleton.component.html',
})
export class TsSkeletonComponent {
  @Input() width: number;
  @Input() height: number;
  @Input() mode: 'default' | 'circle' = 'default';
  @Input() diameter: number;
  @Input() radius = 4;
  @Input() unit: 'px' | '%' = 'px';

  get skeletonBorder() {
    if (this.mode === 'circle') return '50%';

    return `${this.radius}${this.unit}`;
  }

  get skeletonWidth(): string {
    if (this.mode === 'circle') return this.skeletonDiameter;

    if (!isNaN(this.width)) return `${this.width}${this.unit}`;

    return `100%`;
  }

  get skeletonHeight(): string {
    if (this.mode === 'circle') return this.skeletonDiameter;

    if (!isNaN(this.height)) return `${this.height}${this.unit}`;

    return `34px`;
  }

  private get skeletonDiameter(): string {
    if (!isNaN(this.diameter)) return `${this.diameter}${this.unit}`;

    return `50px`;
  }
}
